export const MessageContainerPrefixId = `mx-message-container`
